import { dependencies } from '@pn/core/dependencies';
import type { SearchResult } from '@pn/core/domain/search';
import { useBuildSliceSelector } from '@pn/services/redux/useBuildSliceSelector';
import { searchSlice } from './searchSlice';

export const useSearchStorage = () => {
  const { name, getInitialState } = searchSlice;

  const useSliceSelector = useBuildSliceSelector(name, getInitialState());

  return {
    isError: useSliceSelector((state) => state.isError),
    isFetching: useSliceSelector((state) => state.isFetching),
    searchResults: useSliceSelector((state) => state.searchResults),
  };
};

export const searchActions = () => {
  const { dispatch } = dependencies.store;
  const { actions } = searchSlice;

  return {
    request: () => dispatch(actions.request()),
    receive: (results: SearchResult[]) => dispatch(actions.receive(results)),
    error: () => dispatch(actions.error()),
    reset: () => dispatch(actions.reset()),
  };
};
